// @ts-nocheck
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { calculateAge } from './utils';

export const generateAssessmentPDF = (child, assessment) => {
    const doc = new jsPDF();

    // --- Header ---
    doc.setFontSize(20);
    doc.setFont('helvetica', 'bold');
    doc.text('Laporan Hasil Pemeriksaan SDIDTK', 105, 20, { align: 'center' });
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text(`Tanggal Pemeriksaan: ${assessment.createdAt.toDate().toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' })}`, 105, 28, { align: 'center' });

    doc.line(20, 35, 190, 35); // Horizontal line

    // --- Child's Data ---
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('Data Anak', 20, 45);
    doc.autoTable({
        startY: 50,
        body: [
            ['Nama', `: ${child.name}`],
            ['Tanggal Lahir', `: ${child.dob.toDate().toLocaleDateString('id-ID')}`],
            ['Usia Saat Diperiksa', `: ${calculateAge(child.dob.toDate())}`],
            ['Jenis Kelamin', `: ${child.gender}`],
        ],
        theme: 'plain',
        styles: {
            cellPadding: 1.5,
            fontSize: 11,
        },
    });

    // --- Assessment Results ---
    const finalY = doc.lastAutoTable.finalY || 75;
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('Ringkasan Hasil Pemeriksaan', 20, finalY + 15);

    const tableBody = [];

    // Define all assessment sections with their titles
    const assessmentSections = [
        // Basic assessments
        { key: 'pertumbuhan', title: 'Pertumbuhan Fisik' },
        { key: 'perkembangan', title: 'Perkembangan (KPSP)' },
        { key: 'mental', title: 'Mental Emosional (KMME)' },

        // Specialized assessments
        { key: 'dayaDengar', title: 'Tes Daya Dengar (TDD)' },
        { key: 'gpph', title: 'Gangguan Perhatian & Hiperaktivitas (GPPH)' },
        { key: 'chat', title: 'Autisme (CHAT)' },

        // Eye examination (nested structure)
        { key: 'pemeriksaanMata.pupilPutih', title: 'Pemeriksaan Mata - Pupil Putih' },
        { key: 'pemeriksaanMata.dayaLihat', title: 'Pemeriksaan Mata - Daya Lihat (TDL)' }
    ];

    assessmentSections.forEach(section => {
        let data = null;

        // Handle nested structure for eye examination
        if (section.key.includes('.')) {
            const [parent, child] = section.key.split('.');
            if (assessment[parent] && assessment[parent][child]) {
                data = assessment[parent][child];
            }
        } else if (assessment[section.key]) {
            data = assessment[section.key];
        }

        if (data) {
            tableBody.push([
                section.title,
                data.status || 'N/A',
                data.interpretasi || 'N/A',
                data.detail || 'N/A'
            ]);
        }
    });

    doc.autoTable({
        startY: finalY + 20,
        head: [['Aspek Pemeriksaan', 'Status', 'Interpretasi', 'Detail']],
        body: tableBody,
        theme: 'striped',
        headStyles: { fillColor: [22, 160, 133] }, // A shade of teal
    });

    // --- Footer ---
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(9);
        doc.setTextColor(150);
        doc.text(`Laporan ini dibuat oleh aplikasi SDIDTK | Halaman ${i} dari ${pageCount}`, 105, 285, { align: 'center' });
    }

    // --- Save the PDF ---
    doc.save(`Laporan_SDIDTK_${child.name.replace(/\s/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`);
};

export const generatePdfFromElement = (elementId: string, filename: string) => {
    console.warn("generatePdfFromElement has not been fully ported yet.");
};
